export interface ICountry {
  id: number | null;
  name: string | null;
  code: string | null;
}

export class Country implements ICountry {
  id;
  name;
  code;

  constructor(config: ICountry) {
    this.id = config.id;
    this.name = config.name;
    this.code = config.code;
  }
}
